// Travelpayouts affiliate settings for planettransfers.online.
// marker = Travelpayouts account ID, trs = the planettransfers.online project
// (the planettransfers.com project is a different trs — never use it here).
export const TP_MARKER = '560958';
export const TP_TRS = '588642';

const KIWITAXI_COLORS = {
  bg_color: '#ffffff',
  button_color: '#1a3a6e',
  button_font_color: '#ffffff',
  button_hover_color: '#152e58',
  border_color: '#e2e8f0',
  input_font_color: '#0f172a',
  input_bg_color: '#ffffff',
  input_label_color: '#64748b',
  icon_bg_color: '#ffffff',
  icon_arrow_color: '#64748b',
  icon_bg_color_mobile: '#1a3a6e',
  icon_arrow_color_mobile: '#ffffff',
  autocomplete_font_color: '#0f172a',
  autocomplete_bg_color: '#ffffff',
  autocomplete_font_color_active: '#ffffff',
  autocomplete_bg_color_active: '#1a3a6e',
  loader_color: '#1a3a6e',
  empty_color: '#0f172a',
  info_bg_color: '#f1f5f9',
  info_icon_color: '#475569',
  info_caption_color: '#475569',
  class_background: '#ffffff',
  class_font_color: '#0f172a',
  class_header_color: '#64748b',
  class_button_background: '#1a3a6e',
  class_button_font_color: '#ffffff',
  class_button_background_hover: '#152e58',
  class_comment_background: '#e2e8f0',
  class_comment_font: '#64748b',
  more_font_color: '#0071c2',
  notification_background: '#fffbeb',
  notification_border_color: '#f59e0b',
  notification_color: '#0f172a',
  transfer_background: '#f8fafc',
  transfer_background_hover: '#f1f5f9',
  transfer_font_color: '#0f172a',
};

// Kiwitaxi "Shuttles Search Form" (Travelpayouts promo 2949): search + results
// render inside the widget, so the visitor stays on our page until checkout.
export function kiwitaxiSearchWidgetSrc(currency = 'EUR') {
  const params = new URLSearchParams({
    currency: currency.toUpperCase(),
    trs: TP_TRS,
    shmarker: TP_MARKER,
    locale: 'en',
    from: '',
    to: '',
    country: '',
    powered_by: 'false',
    height: '',
    wtype: 'true',
    transfers_limit: '10',
    ...KIWITAXI_COLORS,
    campaign_id: '1',
    promo_id: '2949',
  });
  return `https://tpscr.com/content?${params.toString()}`;
}

// Hotel widget for the post-payment page. Travelpayouts is still reviewing the
// hotel programs (Booking.com, Trip.com, Agoda…) for this project. Once one is
// approved, paste the widget's script src here and the section appears.
export const HOTELS_WIDGET_SRC = '';

// Cross-sell widgets. Each loader script finds itself by promo_id and renders
// next to its own <script> tag; campaign_id is the Travelpayouts program id.
function tpWidgetSrc(campaignId, promoId, extra = {}) {
  const params = new URLSearchParams({
    trs: TP_TRS,
    shmarker: TP_MARKER,
    powered_by: 'false',
    ...extra,
    campaign_id: String(campaignId),
    promo_id: String(promoId),
  });
  return `https://tpscr.com/content?${params.toString()}`;
}

// GetRentacar.com search form (10%, 90-day cookie): worldwide car rental search.
export const CAR_RENTAL_WIDGET_SRC = tpWidgetSrc(222, 8813, { locale: 'en' });

// Airalo eSIM search form (12%).
export const ESIM_WIDGET_SRC = tpWidgetSrc(541, 8588, { locale: 'en' });

// Tiqets "Popular Tours" (3.5–8%). Quirk of this loader: the Tiqets city id
// goes in the `locale` param, so no language locale may be passed here.
export function toursWidgetSrc(tiqetsCityId, currency = 'EUR', cards = 4) {
  return tpWidgetSrc(89, 3947, {
    locale: String(tiqetsCityId),
    currency: currency.toUpperCase(),
    language: 'en',
    cards: String(cards),
    layout: 'horizontal',
  });
}

// Tiqets city ids, checked against tiqets.com/en/…-c<id>/ on 2026-10-22.
export const TOUR_CITIES = [
  { name: 'London', tiqetsId: 67458 },
  { name: 'Paris', tiqetsId: 66746 },
  { name: 'Rome', tiqetsId: 71631 },
  { name: 'Barcelona', tiqetsId: 66342 },
  { name: 'Amsterdam', tiqetsId: 75061 },
  { name: 'Dubai', tiqetsId: 60005 },
];

// Picks the tour city that a free-text address mentions, e.g. a drop-off of
// "Hotel Arts, Barcelona, Spain" → Barcelona. Returns null when none match.
export function tourCityFor(address = '') {
  const text = address.toLowerCase();
  return TOUR_CITIES.find(c => text.includes(c.name.toLowerCase())) || null;
}
